import { render, staticRenderFns } from "./CountryDdiSelect.vue?vue&type=template&id=590c11a7&scoped=true&"
import script from "./CountryDdiSelect.vue?vue&type=script&lang=js&"
export * from "./CountryDdiSelect.vue?vue&type=script&lang=js&"
import style0 from "./CountryDdiSelect.vue?vue&type=style&index=0&id=590c11a7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590c11a7",
  null
  
)

export default component.exports